module.exports = __webpack_public_path__ + "img/bg_bolao.abd5df27.png";